import {
  ShieldCheckIcon,
  PresentationChartBarIcon,
  Cog6ToothIcon,
  ArrowTrendingUpIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

const BuiltForPros = () => {
  return (
    <section id="built-for-pros" className="w-full">
      {/* Match hero background: no grey band, just generous vertical spacing */}
      <div className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-8 md:px-12">
          <div className="text-center">
            {/* Heading size/style matches How it works */}
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl md:text-5xl">
              Built for event professionals
            </h2>
            <p className="mt-3 text-base text-slate-600 md:text-lg">Everything you need to price with confidence</p>
          </div>

          <div className="mt-12 grid gap-6 sm:grid-cols-2">
            {/* Card 1: Quick analysis */}
            <div className="relative rounded-3xl border border-slate-200 bg-white p-10 md:p-12 shadow-md">
              <SparklesIcon className="absolute left-5 top-5 h-10 w-10 text-[color:var(--color-primary)]" />
              <h3 className="mt-10 text-base font-semibold text-slate-900">Quick analysis</h3>
              <p className="mt-3 text-base leading-relaxed text-slate-600">
                Compress days or weeks of research into minutes.
              </p>
            </div>

            {/* Card 2: Comprehensive benchmarking */}
            <div className="relative rounded-3xl border border-slate-200 bg-white p-10 md:p-12 shadow-md">
              <PresentationChartBarIcon className="absolute left-5 top-5 h-10 w-10 text-[color:var(--color-primary)]" />
              <h3 className="mt-10 text-base font-semibold text-slate-900">Comprehensive benchmarking</h3>
              <p className="mt-3 text-base leading-relaxed text-slate-600">
                Compare against bars, festivals, stadiums, and VIP events to see where you stand.
              </p>
            </div>

            {/* Card 3: Actionable insights */}
            <div className="relative rounded-3xl border border-slate-200 bg-white p-10 md:p-12 shadow-md">
              <Cog6ToothIcon className="absolute left-5 top-5 h-10 w-10 text-[color:var(--color-primary)]" />
              <h3 className="mt-10 text-base font-semibold text-slate-900">Actionable insights</h3>
              <p className="mt-3 text-base leading-relaxed text-slate-600">
                Get clear recommendations on which items to adjust and by how much to maximize revenue.
              </p>
            </div>

            {/* Card 4: Client-ready reports */}
            <div className="relative rounded-3xl border border-slate-200 bg-white p-10 md:p-12 shadow-md">
              <ArrowTrendingUpIcon className="absolute left-5 top-5 h-10 w-10 text-[color:var(--color-primary)]" />
              <h3 className="mt-10 text-base font-semibold text-slate-900">Client-ready reports</h3>
              <p className="mt-3 text-base leading-relaxed text-slate-600">
                Beautiful, shareable reports you can present directly to clients or stakeholders.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuiltForPros;
